import { NavLink } from "react-router";
import { t } from "../i18n";
import { PRICING_PUBLIC } from "../flags";
import { useBillingState } from "../billing";

/** Plan states without a subscription: Pricing is offered in the header (owner 2026-10-15). A gift with a subscription
 *  that starts after it reads as `active`, so it is not offered there; comp, admin and billing off never see it. */
const NO_SUBSCRIPTION = new Set(["trial", "trial-ending", "expired", "gift"]);

/** «Pricing» as the last navigation pill for a signed-in user with no subscription, sky as the Pricing page (ADR-0060). */
export function PricingNavLink() {
  const { state } = useBillingState(true);
  if (!PRICING_PUBLIC || !state || !NO_SUBSCRIPTION.has(state.plan.state)) return null;
  return (
    <NavLink to="/pricing" className="tone-sky">
      {t("nav.pricing")}
    </NavLink>
  );
}
